<template src="./index.html" />

<script>
import * as XLSX from 'xlsx'
import {
  BBreadcrumb, BButton, BFormFile, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, BFormCheckbox, BFormRadio,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import {
  showErrorToast, showSuccessToast, showWarningToast, showInfoToast,
} from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { ApiCode } from '@/const/api'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'Student',
  components: {
    BBreadcrumb,
    BButton,
    BFormFile,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    XLSX,
    VueGoodTable,
    BFormCheckbox,
    BFormRadio,
  },
  props: {

  },
  data() {
    return {
      user: getUser(),
      table: {
        fields: [
          {
            field: 'stt', label: 'STT', sortable: false, type: 'string',
          },
          {
            field: 'code', label: 'Mã sinh viên(*)', sortable: false, type: 'string',
          },
          {
            field: 'lastName', label: 'Họ đệm(*)', sortable: false, type: 'string',
          },
          {
            field: 'name', label: 'Tên(*)', sortable: false, type: 'string',
          },
          {
            field: 'identifyCode', label: 'CCCD', sortable: false, type: 'string',
          },
          {
            field: 'email', label: 'Email', sortable: false, type: 'string',
          },
          {
            field: 'passportCode', label: 'Hộ khẩu', sortable: false, type: 'string',
          },
          {
            field: 'birthday', label: 'Ngày sinh(*)', sortable: false, type: 'string',
          },
          {
            field: 'gender', label: 'Giới tính(*)', sortable: false, type: 'string',
          },
          {
            field: 'birthPlace', label: 'Nơi sinh', sortable: false, type: 'string',
          },
          {
            field: 'parentEmail', label: 'Email phụ huynh', sortable: false, type: 'string',
          },
          {
            field: 'permanentResidence', label: 'Hộ khẩu', sortable: false, type: 'string',
          },
          {
            field: 'classCode', label: 'Lớp(*)', sortable: false, type: 'string',
          },
          {
            field: 'provinceCode', label: 'Mã tỉnh', sortable: false, type: 'string',
          },
          {
            field: 'wardCode', label: 'Mã xã', sortable: false, type: 'string',
          },
          {
            field: 'address', label: 'Địa chỉ LH', sortable: false, type: 'string',
          },
          {
            field: 'religionCode', label: 'Mã tôn giáo', sortable: false, type: 'string',
          },
          {
            field: 'ethnicCode', label: 'Mã dân tộc', sortable: false, type: 'string',
          },
          {
            field: 'policyId', label: 'Mã CĐCS', sortable: false, type: 'string',
          },
          {
            field: 'profileId', label: 'Mã hồ sơ', sortable: false, type: 'string',
          },
        ],
        items: [],
      },
      tenFile: '',
      dataExcel: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10,
      },
      loading: false,
      selected: '',
      numberConfig: 1,
      distinctClassCode: [],
      valueSetup: 0,
    }
  },
  computed: {
    ...mapGetters({
      total: 'rooms/total',
      accounts: 'account/accounts',
      configStudentCode: 'configStudentCode/dataLists',
    }),
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.IMPORT_STUDENT)
    },
  },
  async created() {
    this.loading = true
    try {
      await this.getConfigStudentCode()
      this.valueSetup = parseInt(this.configStudentCode.find(item => item.code === 'COUNT').value)
      this.numberConfig = parseInt(this.configStudentCode.find(item => item.code === 'NUMBER').value)
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      importStudents: 'importStudent/importStudents',
      selectCourseByClassCode: 'importStudent/selectCourseByClassCode',
      selectMajorByClassCode: 'importStudent/selectMajorByClassCode',
      classes: 'classes/getClasses',
      getListAccount: 'account/getListAccount',
      getConfigStudentCode: 'configStudentCode/getData',
    }),
    async importExcel(e) {
      const headerItem = {
        field: 'codeOld', label: 'Mã học sinh cũ', sortable: false, type: 'string',
      }
      if (this.selected) {
        this.table.fields.push(headerItem)
      }
      const { files } = e.target
      if (!files.length) {
        return
      } if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        // show err
      }
      if (files[0].name) {
        this.tenFile = files[0].name
      }
      this.readFile(files)
    },

    readFile(files) {
      const fileReader = new FileReader()
      fileReader.onload = async ev => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsname = workbook.SheetNames[0]
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            header: 0,
            defval: '',
          })
          const excellist = []
          // Edit data
          if (ws.length > 0) {
            for (let i = 0; i < ws.length; i++) {
              excellist.push(ws[i])
            }
          } else {
            showErrorToast(this, 'File không có dữ liệu')
            return
          }
          if (
            !excellist[0].hasOwnProperty('MA_SINH_VIEN')
            || !excellist[0].hasOwnProperty('HO_DEM')
            || !excellist[0].hasOwnProperty('TEN')
            || !excellist[0].hasOwnProperty('CCCD')
            || !excellist[0].hasOwnProperty('EMAIL')
            || !excellist[0].hasOwnProperty('HO_CHIEU')
            || !excellist[0].hasOwnProperty('NGAY_SINH')
            || !excellist[0].hasOwnProperty('GIOI_TINH')
            || !excellist[0].hasOwnProperty('NOI_SINH')
            || !excellist[0].hasOwnProperty('HO_KHAU')
            || !excellist[0].hasOwnProperty('MA_LOP')
            || !excellist[0].hasOwnProperty('MA_TINH')
            || !excellist[0].hasOwnProperty('MA_XA')
            || !excellist[0].hasOwnProperty('DIA_CHI_LH')
            || !excellist[0].hasOwnProperty('MA_TON_GIAO')
            || !excellist[0].hasOwnProperty('MA_DAN_TOC')
            || !excellist[0].hasOwnProperty('MA_CDCS')

          ) {
            showErrorToast(this, 'File chưa đúng định dạng')
            return
          }

          this.dataExcel = []
          // eslint-disable-next-line no-plusplus
          for (let k = 0; k < excellist.length; k++) {
            const item = excellist[k]
            const obj = {
              stt: k + 1,
              name: item.TEN.toString().trim(),
              lastName: item.HO_DEM,
              code: item.MA_SINH_VIEN,
              identifyCode: item.CCCD,
              email: item.EMAIL || null,
              passportCode: item.HO_CHIEU,
              orderNo: '',
              birthday: item.NGAY_SINH,
              relatedId: null,
              organizationId: this.user.orgId,
              studentId: null,
              classCode: item.MA_LOP,
              birthPlace: item.NOI_SINH,
              parentEmail: item.EMAIL_PHU_HUYNH,
              gender: item.GIOI_TINH ? item.GIOI_TINH : 0,
              address: item.DIA_CHI_LH,
              permanentResidence: item.HO_KHAU,
              wardCode: item.MA_XA,
              provinceCode: item.MA_TINH,
              religionCode: item.MA_TON_GIAO,
              ethnicCode: item.MA_DAN_TOC,
              policyCode: item.MA_CDCS,
              dateEnter: '',
              status: 1,
              delFlag: 0,
              createdBy: null,
              codeOld: item.MA_SINH_VIEN_CU ? item.MA_SINH_VIEN_CU : '',
              isLienThong: this.selected ? '1' : '0',
            }
            this.dataExcel.push(obj)
          }
          this.table.items = this.dataExcel
          this.totalRecords = this.dataExcel.length
          if (this.totalRecords > 10) {
            this.table.items = this.dataExcel.slice(0, 10)
          }

          // insert ban ghi
        } catch (e) {
          return alert(`Read failure!${e}`)
        }
      }
      fileReader.readAsBinaryString(files[0])
    },

    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },

    isValidDateFormat(dateString) {
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/
      return regex.test(dateString)
    },

    checkDataBeforeImport(dataArray) {
      if (dataArray.length === 0) {
        showWarningToast(this, 'Chưa có dữ liệu để thực hiện')
        return false
      }
      const studentCodes = new Set()

      const cccdNumbers = new Set()
      // Kiểm tra các điều kiện trong từng object của mảng
      for (const subArray of dataArray) {
        const {
          code, lastName, name, gender, classCode, birthday, identifyCode,
        } = subArray

        // Kiểm tra các trường không được rỗng
        if (!code || !lastName || !name || (gender === null || gender === undefined || gender.toString().trim() === '') || !classCode || !birthday
        ) {
          showWarningToast(this, 'Các trường thông tin [MA_SINH_VIEN, HO_DEM, TEN, GIOI_TINH, MGAY_SINH, MA_LOP] không được trống')
          return false
        }

        if (studentCodes.has(code)) {
          showWarningToast(this, `Mã sinh viên  ${code} đang bị trùng lặp, vui lòng kiểm tra lại dữ liệu, `)
          return false
        }
        studentCodes.add(code)

        // if (cccdNumbers.has(identifyCode)) {
        //   this.showToast(`Mã CCCD  ${identifyCode} đang bị trùng lặp, vui lòng kiểm tra lại dữ liệu, `, 'InfoIcon', 'warning', '')
        //   return false
        // }
        // cccdNumbers.add(identifyCode)

        // Kiểm tra trường GIOI_TINH chỉ nhận giá trị '0', '1' hoặc '2'
        if (gender.toString() !== '0' && gender.toString() !== '1' && gender.toString() !== '2') {
          showWarningToast(this, 'Thông tin giới tính vui lòng chỉ điền 0, 1 hoặc 2')
          return false
        }

        // Kiểm tra trường NGAY_SINH
        if (!this.isValidDateFormat(birthday.toString().trim())) {
          showWarningToast(this, 'Thông tin ngày sinh không đúng dịnh dạng quy định dd/MM/yyyy')
          return false
        }
      }
      return true
    },

    async importStudent() {
      const data = this.dataExcel
      if (this.checkDataBeforeImport(data)) {
        try {
          this.loading = true
          const res = await this.importStudents(data)
          if (res.code === ApiCode.SUCCESS) {
            showSuccessToast(this, 'Lưu thành công')
            this.resetInputFile()
          } else {
            showErrorToast(this, res.message || 'Có lỗi xảy ra')
          }
        } catch (e) {
          this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger', '')
        } finally {
          this.loading = false
        }
      }
    },

    async createCode() {
      this.loading = true
      try {
        // Lấy danh sách classCode
        const uniqueClassCodes = new Set(this.dataExcel.map(item => item.classCode))
        // Chuyển đổi Set thành mảng
        const uniqueClassCodesArray = Array.from(uniqueClassCodes)
        const strClassCode = uniqueClassCodesArray.toString()
        const param = {
          strClassCode,
        }
        const [data, dataMajor] = await Promise.all([
          this.selectCourseByClassCode(param),
          this.selectMajorByClassCode(param),
          this.getListAccount(),
        ])

        // lay danh sách khóa học theo mã lớp
        const arrData = []
        for (let i = 0; i < uniqueClassCodesArray.length; i++) {
          const obj = {
            id: uniqueClassCodesArray[i],
            name: data.data[i].code,
            majorCode: dataMajor.data[i].code,
            maxUsername: this.findMaxStructuredUsername(data.data[i].code, dataMajor.data[i].code),
          }
          arrData.push(obj)
        }
        for (let i = 0; i < this.dataExcel.length; i++) {
          const courseCode = arrData.find(item => item.id === this.dataExcel[i].classCode).name
          const { majorCode } = arrData.find(item => item.id === this.dataExcel[i].classCode)
          this.dataExcel[i].courseCode = courseCode
          this.dataExcel[i].majorCode = majorCode
        }
        this.dataExcel.sort((a, b) => {
          if (a.classCode < b.classCode) return -1
          if (a.classCode > b.classCode) return 1
          return 0
        })

        let currentClass = this.dataExcel[0].classCode
        let maxUser = arrData.find(item => item.id === this.dataExcel[0].classCode).maxUsername
        let j = 0
        for (let i = 0; i < this.dataExcel.length; i++) {
          const { courseCode, majorCode } = this.dataExcel[i]
          if (currentClass !== this.dataExcel[i].classCode) {
            j = 1
            currentClass = this.dataExcel[i].classCode
            maxUser = arrData.find(item => item.id === currentClass).maxUsername
          } else {
            j++
          }

          const generatedUsername = this.generateUsername(courseCode, majorCode, maxUser + j)
          this.dataExcel[i].code = generatedUsername
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.loading = false
      }
    },

    findMaxStructuredUsername(courseCode, majorCode) {
      let currentYear = new Date().getFullYear()
      currentYear = currentYear.toString().slice(-2)
      let maxNumber = -1
      const negativeNumber = -this.numberConfig
      let findRegex = '^'
      const configs = this.configStudentCode.filter(item => item.active === 1)

      configs.forEach(config => {
        switch (config.code) {
          case 'NAM': // Năm hiện tại
            findRegex += currentYear
            break
          case 'CODE_COURSE': // Mã khóa học
            findRegex += courseCode
            break
          case 'CODE_MAJOR': // Mã chuyên ngành
            findRegex += majorCode
            break
          case 'NUMBER': // Số random
            findRegex += `\\d{${config.value}}`
            this.numberConfig = config.value
            break
        }
      })

      findRegex += '$'
      let maxAccount = ''
      this.accounts.forEach(username => {
        const number = parseInt(username.value.slice(negativeNumber)) // Lấy n ký tự số cuối cùng
        if (number > maxNumber) {
          maxNumber = number
          maxAccount = username
        }
      })

      if (maxNumber < this.valueSetup) {
        maxNumber = this.valueSetup
      }

      return maxNumber
    },

    generateUsername(courseCode, majorCode, number) {
      let currentYear = new Date().getFullYear()
      // lấy 2 số cuối cùng của năm
      currentYear = currentYear.toString().slice(-2)
      const configs = this.configStudentCode.filter(item => item.active === 1)
      let username = ''
      configs.forEach(config => {
        switch (config.code) {
          case 'NAM': // Năm hiện tại
            username += currentYear
            break
          case 'CODE_COURSE': // Mã khóa học
            username += courseCode
            break
          case 'CODE_MAJOR': // Mã chuyên ngành
            username += majorCode
            break
          case 'NUMBER': // Số random
            const strNumber = number.toString().padStart(this.numberConfig - (number.toString().length), '0')
            username += strNumber
            break
        }
      })
      return username
    },

    // Helper function to create cell style
    createCellStyle() {
      return {
        borders: {
          color: '#00000000',
          lineStyle: 'thin',
        },
        fontColor: '#ffffff',
        backColor: '#000000',
      }
    },

    // Helper function to create cell
    createCell(index, value) {
      return {
        index,
        value,
        colSpan: 1,
        style: this.createCellStyle(),
      }
    },

    // Get Excel configuration (columns and headers)
    getExcelConfig() {
      // Define base configuration for all fields
      const baseConfig = [
        { field: 'MA_SINH_VIEN', width: 130 },
        { field: 'HO_DEM', width: 130 },
        { field: 'TEN', width: 100 },
        { field: 'CCCD', width: 130 },
        { field: 'EMAIL', width: 200 },
        { field: 'HO_CHIEU', width: 130 },
        { field: 'NGAY_SINH', width: 200 },
        { field: 'GIOI_TINH', width: 200 },
        { field: 'NOI_SINH', width: 130 },
        { field: 'HO_KHAU', width: 130 },
        { field: 'MA_LOP', width: 130 },
        { field: 'MA_TINH', width: 130 },
        { field: 'MA_XA', width: 130 },
        { field: 'DIA_CHI_LH', width: 130 },
        { field: 'MA_TON_GIAO', width: 130 },
        { field: 'MA_DAN_TOC', width: 130 },
        { field: 'MA_CDCS', width: 130 },
        { field: 'EMAIL_PHU_HUYNH', width: 130 },
      ]

      // Add additional field if selected mode is enabled
      if (this.selected) {
        baseConfig.push({ field: 'MA_SINH_VIEN_CU', width: 100 })
      }

      // Generate columns configuration
      const columns = baseConfig.map((config, index) => ({
        index: index + 1,
        width: config.width,
      }))

      // Generate header row configuration
      const cells = baseConfig.map((config, index) => this.createCell(index + 1, config.field))

      return {
        columns,
        headerRow: {
          index: 1,
          cells,
        },
      }
    },

    // Generate filename with timestamp
    generateFilename() {
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
      return `import_SinhVienLopCoDinh_${timestamp}.xlsx`
    },

    // Main download function
    downloadFile() {
      try {
        showInfoToast(this, 'Đang tạo file template...')

        // Get Excel configuration (columns and headers)
        const { columns, headerRow } = this.getExcelConfig()
        const rows = [headerRow]

        // Create workbook and save
        const worksheets = [{ columns, rows }]
        const workbook = new Workbook({ worksheets }, 'xlsx')
        const filename = this.generateFilename()

        workbook.save(filename)

        showSuccessToast(this, 'Tải xuống thành công!')
      } catch (error) {
        showErrorToast(this, 'Không thể tạo file template. Vui lòng thử lại.')
      }
    },
    // handle even

    showToast(title, icon, variant, text) {
      if (variant === 'success') return showSuccessToast(this, title)
      if (variant === 'danger') return showErrorToast(this, title)
      if (variant === 'warning') return showWarningToast(this, title)
      return showInfoToast(this, title)
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage
      const start = params.currentPerPage * (params.currentPage - 1)
      const end = this.dataExcel.length > (params.currentPerPage * params.currentPage) ? (params.currentPerPage * params.currentPage) : this.dataExcel.length
      this.table.items = this.dataExcel.slice(start, end)
    },

    onPerPageChange(params) {
      this.serverParams.perPage = params.currentPerPage
      const start = params.currentPerPage * (params.currentPage - 1)
      const end = this.dataExcel.length > (params.currentPerPage * params.currentPage) ? (params.currentPerPage * params.currentPage) : this.dataExcel.length
      this.table.items = this.dataExcel.slice(start, end)
    },

    handleChecked() {
    },

  },
}
</script>

<style type="text/css">
.form_file{
  width: auto !important;
}
</style>
